import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { BrComponent } from '@bloomreach/react-sdk';
import { generateConditionalClassNames } from '../utils/utils.js';

var CmsRowPDPContainer = ({ component  })=>{
    const _ref = component.getParameters(), { showInDesktop , showInTablet , showInPhone , fullWidth , tabButtonTitle  } = _ref, cssStyles = swcHelpers.objectWithoutProperties(_ref, [
        "showInDesktop",
        "showInTablet",
        "showInPhone",
        "fullWidth",
        "tabButtonTitle"
    ]);
    const filteredStyles = Object.fromEntries(Object.entries(cssStyles).filter(([_, value])=>value !== ''
    ));
    const rowClassName = generateConditionalClassNames('br-row-pdp', {
        fullWidth,
        showInDesktop,
        showInTablet,
        showInPhone
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: rowClassName,
        "data-t": "br-row-pdp",
        style: swcHelpers.objectSpread({}, filteredStyles)
    }, /*#__PURE__*/ React.createElement(BrComponent, null));
};

export { CmsRowPDPContainer, CmsRowPDPContainer as default };
//# sourceMappingURL=RowPDPContainer.js.map
